export class StudyNotFoundError extends Error {}
